import { Event } from '@/modules/tracking/types'
export default class LoginEvent extends Event {
  constructor(label: string) {
    super('Login', 'Nutzer hat sich eingeloggt', label)
  }
  static readonly Login = new LoginEvent('Manueller Login')
  static readonly Punchout = new LoginEvent('Punchout')
  static readonly OAuth = new LoginEvent('OAuth')
}
